import type { NavGroupProps } from 'src/components/nav-section';

import { navDataManage } from './config';

import type { pathNavManage } from './config';

const permissionsForManage: string[] = [
  'learning-progress',
  'user',
  'user/list',
  'course/*',
  'question/*',
  'calendar/*',
  'chat',
  'survey',
  'notify/*',
  'export-report',
  'export-report/detail-report',
  'file-manager',
];

function hasPermission(path: string, permissions: string[]) {
  return permissions.some((perm) => {
    if (perm === path) {
      return true;
    }
    if (perm.endsWith('/*')) {
      const prefix = perm.slice(0, -2);
      const match = path === prefix || path.startsWith(`${prefix}/`);
      return match;
    }
    return false;
  });
}

function filterNavItems(items: any[], permissions: string[], role?: pathNavManage): any[] {
  const roleBasedPermissions = permissions.map((perm) =>
    role ? (perm.startsWith('/') ? `/${role}${perm}` : `/${role}/${perm}`) : perm
  );

  return items
    .map((item) => {
      if (!hasPermission(item.path, roleBasedPermissions)) return null;
      const newItem = { ...item };
      if (item.children) {
        newItem.children = filterNavItems(item.children, roleBasedPermissions);
      }
      return newItem;
    })
    .filter(Boolean);
}

export const navData = (role: 'administrator' | 'manage'): NavGroupProps[] => {
  const fullData = navDataManage(role);

  if (role === 'administrator') return fullData;

  return fullData.map((group) => ({
    ...group,
    items: filterNavItems(group.items, permissionsForManage, role),
  }));
};
